import { MoreVert } from '@mui/icons-material'
import { IconButton, Menu, MenuItem } from '@mui/material'
import { CustomModalContext } from 'common/contexts/CustomModalContext'
import { ModalTypes } from 'common/hooks/useCustomModal'
import FilesHelper from 'common/libs/Files'
import { enqueueSnackbar } from 'notistack'
import { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import InformesHelper from '../helpers/InformesHelper'
import { InformesContext } from '../providers/InformesProvider'

/**
 * @param {object} props
 * @param {InformePluginConfig} props.plugin
 */
const InformePluginButton = ({ plugin, element, onClick }) => {
  const { active, setRedirected, previous } = useContext(InformesContext)
  const { handleModal } = useContext(CustomModalContext)
  const navigate = useNavigate()

  function lanzarPluginPL(filters) {
    handleModal({ type: ModalTypes.Loading, enabled: true })
    InformesHelper.runPLplugin(plugin.informe_origen, plugin.codigo, filters)
      .then((data) => {
        handleModal({ type: ModalTypes.Loading, enabled: false })
        if (data.post_ok) {
          enqueueSnackbar(data.post_ok, {
            variant: 'success',
            autoHideDuration: 10000,
          })
        }

        if (data.post_ko) {
          enqueueSnackbar(data.post_ko, {
            variant: 'error',
            autoHideDuration: 10000,
          })
        }
      })
      .catch((error) => {
        enqueueSnackbar(error.message, {
          variant: 'error',
          autoHideDuration: 10000,
        })
      })
  }

  async function callProgram(filters) {
    switch (plugin.programa_llamado) {
      case 'efactura':
        handleModal({ type: ModalTypes.Loading, enabled: true })
        await InformesHelper.obtenerEfactura({
          numero_factura: filters.NUMERO_FACTURA,
          ejercicio: filters.EJERCICIO,
          numero_serie: filters.NUMERO_SERIE,
        })
          .then((data) => {
            if (Array.isArray(data.registros)) {
              for (var i = 0; i < data.registros.length; i++) {
                var registro = data.registros[i]
                FilesHelper.blobDownload(registro.archivo, 'pdf', registro.nombre_archivo)
              }
            } else {
              FilesHelper.blobDownload(
                data.registros.registro.archivo,
                'pdf',
                data.registros.registro.nombre_archivo,
              )
            }
          })
          .catch(() => {
            enqueueSnackbar('La petición ha fallado', { variant: 'error' })
          })
          .finally(() => {
            handleModal({ type: ModalTypes.Loading, enabled: false })
          })

        break
      case 'descargaArchivo':
        handleModal({ type: ModalTypes.Loading, enabled: true })
        await FilesHelper.downloadFile(
          null,
          null,
          `informes/descargararchivotoken/${filters.TOKEN}/`,
        )
          .catch(() => {
            enqueueSnackbar('La petición ha fallado', { variant: 'error' })
          })
          .finally(() => {
            handleModal({ type: ModalTypes.Loading, enabled: false })
          })
        break
      default:
        break
    }
  }

  function redirect(filtersToAply) {
    const original = {
      nombre: active.current.nombre,
      nombre_informe: active.current.nombre_informe,
      activeFilter: active.activeFilter,
      page: active.page,
      previousReport: previous?.previousReport ? previous.previousReport : {},
    }
    previous.setPreviousReport(original)
    active.setCurrent({
      nombre_informe: plugin.informe_llamado,
      nombre: plugin.descripcion,
      isNestedReport: true,
    })
    active.setPage(1)
    active.setActiveFilter(filtersToAply)
    active.setFilterData(filtersToAply)
    setRedirected(true)
  }

  const click = async () => {
    onClick()
    const filtersToAply = {}

    plugin.filtros.forEach((value) => {
      let position = value.parametro
      var originalName = value.parametro
      if (originalName.startsWith('F_')) {
        position = position.slice(2)
      }

      filtersToAply[position] =
        value.tipo_filtro === 'C' ? value.valor_parametro : element[value.valor_parametro]
    })

    if (plugin.informe_llamado) {
      redirect(filtersToAply)
    }
    if (plugin.report_llamado) {
      handleModal({ enabled: true, type: ModalTypes.Loading })
      InformesHelper.getReport(plugin.report_llamado, filtersToAply)
        .then(({ fichero, nombre }) => FilesHelper.blobDownload(fichero, 'pdf', nombre))
        .finally(() => {
          handleModal({ enabled: false, type: ModalTypes.Loading })
        })
    }
    if (plugin.programa_llamado) {
      callProgram(filtersToAply)
    }
    if (
      plugin.programa_llamado === null &&
      plugin.report_llamado === null &&
      plugin.informe_llamado === null
    ) {
      lanzarPluginPL(filtersToAply)
    }
  }

  return <MenuItem onClick={click}>{plugin.descripcion}</MenuItem>
}

const InformesActionButton = ({ plugins, element }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  function handleClose() {
    setAnchorEl(null)
  }
  return (
    <>
      <IconButton
        sx={{ p: 0, width: '30px', height: '30px' }}
        onClick={(event) => {
          setAnchorEl(event.target)
        }}
      >
        <MoreVert />
      </IconButton>
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        {plugins.map((item, idx) => {
          return (
            <InformePluginButton key={idx} plugin={item} element={element} onClick={handleClose} />
          )
        })}
      </Menu>
    </>
  )
}

export default InformesActionButton
